import { PrinterPosCancelOutlineIcon } from './PrinterPosCancelOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 7D88DD62-B00E-4950-8A0A-CF5C895578E7
 * name printer-pos-cancel-outline
 * version: 7.1.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/printer-pos-cancel-outline.svg
 * tags
 * - Printer 
 */
export const PrinterReceiptCancelOutlineIcon = PrinterPosCancelOutlineIcon;
export default PrinterReceiptCancelOutlineIcon